(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumo-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBA(root) {
    var before = root.querySelector('.lumo-ba__before');
    var beforeImg = root.querySelector('.lumo-ba__before .lumo-ba__img');
    var handle = root.querySelector('.lumo-ba__handle');
    if (!before || !handle) return;

    var pos = parseFloat(root.getAttribute('data-start'));
    if (isNaN(pos)) pos = 50;
    var dragging = false;

    function syncWidth() {
      // La imagen "antes" debe medir lo mismo que todo el contenedor
      // para que no se deforme al recortarla.
      root.style.setProperty('--lumo-ba-w', root.clientWidth + 'px');
    }

    function setPos(p) {
      pos = Math.max(2, Math.min(98, p));
      root.style.setProperty('--pos', pos + '%');
      handle.setAttribute('aria-valuenow', Math.round(pos));
    }

    function posFromX(clientX) {
      var rect = root.getBoundingClientRect();
      if (!rect.width) return pos;
      return ((clientX - rect.left) / rect.width) * 100;
    }

    function onDown(e) {
      dragging = true;
      root.classList.add('is-dragging');
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      setPos(posFromX(x));
      if (e.cancelable) e.preventDefault();
    }
    function onMove(e) {
      if (!dragging) return;
      var x = (e.touches ? e.touches[0].clientX : e.clientX);
      setPos(posFromX(x));
      if (e.cancelable && e.touches) e.preventDefault();
    }
    function onUp() {
      dragging = false;
      root.classList.remove('is-dragging');
    }

    // Ratón
    root.addEventListener('mousedown', onDown);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);

    // Táctil
    root.addEventListener('touchstart', onDown, { passive: false });
    document.addEventListener('touchmove', onMove, { passive: false });
    document.addEventListener('touchend', onUp);
    document.addEventListener('touchcancel', onUp);

    // Teclado (accesibilidad)
    handle.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { setPos(pos - 2); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { setPos(pos + 2); e.preventDefault(); }
      else if (e.key === 'Home') { setPos(2); e.preventDefault(); }
      else if (e.key === 'End') { setPos(98); e.preventDefault(); }
    });

    // Medidas
    syncWidth();
    setPos(pos);
    if (beforeImg) {
      if (beforeImg.complete) syncWidth();
      else beforeImg.addEventListener('load', syncWidth);
    }
    window.addEventListener('load', syncWidth);
    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(syncWidth, 150);
    });
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-lumo-ba]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-lumo-ba-init')) continue;
      nodes[i].setAttribute('data-lumo-ba-init', '1');
      initBA(nodes[i]);
    }
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initAll, 50);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumo-slide"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSlider(root) {
    var track = root.querySelector('.lumo-track');
    var viewport = root.querySelector('.lumo-viewport');
    var dotsWrap = root.querySelector('.lumo-dots');
    var prevBtn = root.querySelector('.lumo-arrow--prev');
    var nextBtn = root.querySelector('.lumo-arrow--next');
    if (!track || !viewport) return;

    var cfg = {
      sd: Math.max(1, parseInt(root.getAttribute('data-slides-desktop'), 10) || 3),
      sm: Math.max(1, parseInt(root.getAttribute('data-slides-mobile'), 10) || 2),
      gapD: parseInt(root.getAttribute('data-gap-desktop'), 10) || 0,
      gapM: parseInt(root.getAttribute('data-gap-mobile'), 10) || 0,
      infinite: root.getAttribute('data-infinite') === 'true',
      autoplay: root.getAttribute('data-autoplay') === 'true',
      speed: Math.max(1000, (parseFloat(root.getAttribute('data-autoplay-speed')) || 5) * 1000),
      fade: root.getAttribute('data-fade') === 'true'
    };

    var originals = [].slice.call(track.querySelectorAll('.lumo-slide'));
    var realCount = originals.length;
    if (!realCount) return;

    var perView, gap, fadeMode, staticMode, index, slideW, allSlides, autoTimer = null, animating = false;

    function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }

    function currentReal() {
      if (typeof index !== 'number') return 0;
      if (staticMode) return 0;
      if (fadeMode) return index;
      if (cfg.infinite) return ((index - perView) % realCount + realCount) % realCount;
      return index;
    }

    function computeSettings() {
      perView = Math.min(isMobile() ? cfg.sm : cfg.sd, realCount);
      gap = isMobile() ? cfg.gapM : cfg.gapD;
      fadeMode = cfg.fade && perView === 1;
      staticMode = fadeMode ? (realCount <= 1) : (realCount <= perView);
    }

    function removeClones() {
      [].slice.call(track.querySelectorAll('.lumo-slide.is-clone')).forEach(function (c) {
        c.parentNode.removeChild(c);
      });
    }

    function measure() {
      var vpW = viewport.clientWidth;
      if (!vpW) return;
      slideW = (vpW - gap * (perView - 1)) / perView;
      allSlides.forEach(function (s) {
        s.style.flex = '0 0 ' + slideW + 'px';
        s.style.maxWidth = slideW + 'px';
        s.style.marginRight = gap + 'px';
      });
    }

    function setPosition(animate) {
      var x = -(index * (slideW + gap));
      track.style.transition = animate ? 'transform .45s cubic-bezier(.22,.61,.36,1)' : 'none';
      track.style.transform = 'translateX(' + x + 'px)';
      if (!animate) { track.offsetHeight; } // reflow para fijar sin animación
    }

    function layout(preserve) {
      var keep = preserve ? currentReal() : 0;
      computeSettings();
      removeClones();
      track.classList.toggle('is-fade', fadeMode);

      originals.forEach(function (s) {
        s.style.flex = '';
        s.style.maxWidth = '';
        s.style.marginRight = '';
        s.style.position = '';
        s.style.opacity = '';
        s.classList.remove('is-active');
      });

      if (fadeMode) {
        allSlides = originals.slice();
        index = Math.min(keep, realCount - 1);
        originals.forEach(function (s, i) {
          s.style.position = (i === index) ? 'relative' : 'absolute';
          s.style.opacity = (i === index) ? '1' : '0';
          s.classList.toggle('is-active', i === index);
        });
      } else if (cfg.infinite && realCount > perView) {
        var i, c;
        for (i = realCount - perView; i < realCount; i++) {
          c = originals[i].cloneNode(true);
          c.classList.add('is-clone'); c.setAttribute('aria-hidden', 'true');
          track.insertBefore(c, originals[0]);
        }
        for (i = 0; i < perView; i++) {
          c = originals[i].cloneNode(true);
          c.classList.add('is-clone'); c.setAttribute('aria-hidden', 'true');
          track.appendChild(c);
        }
        allSlides = [].slice.call(track.querySelectorAll('.lumo-slide'));
        index = perView + keep;
        measure();
        setPosition(false);
      } else {
        allSlides = originals.slice();
        index = Math.min(keep, Math.max(0, realCount - perView));
        measure();
        setPosition(false);
      }

      buildDots();
      updateControls();
      updateDots();
    }

    function move(dir) {
      if (staticMode) return;
      if (fadeMode) { goFade(index + dir); return; }
      if (animating) return;
      if (cfg.infinite) {
        animating = true;
        index += dir;
        setPosition(true);
      } else {
        var max = realCount - perView;
        var target = Math.min(max, Math.max(0, index + dir));
        if (target === index) return;
        animating = true;
        index = target;
        setPosition(true);
      }
      updateControls();
      updateDots();
    }

    function goTo(realIndex) {
      if (staticMode) return;
      if (fadeMode) { goFade(realIndex); return; }
      if (animating) return;
      animating = true;
      index = cfg.infinite ? (perView + realIndex) : Math.min(realCount - perView, Math.max(0, realIndex));
      setPosition(true);
      updateControls();
      updateDots();
    }

    function goFade(target) {
      var n = ((target % realCount) + realCount) % realCount;
      if (n === index) return;
      var cur = originals[index];
      cur.style.opacity = '0';
      cur.classList.remove('is-active');
      window.setTimeout(function () {
        if (!cur.classList.contains('is-active')) cur.style.position = 'absolute';
      }, 500);
      index = n;
      var nx = originals[index];
      nx.style.position = 'relative';
      nx.style.opacity = '1';
      nx.classList.add('is-active');
      updateDots();
    }

    track.addEventListener('transitionend', function (e) {
      if (e.propertyName !== 'transform') return;
      animating = false;
      if (!cfg.infinite || fadeMode || staticMode) return;
      if (index >= perView + realCount) { index -= realCount; setPosition(false); }
      else if (index < perView) { index += realCount; setPosition(false); }
    });

    function updateControls() {
      if (staticMode) {
        if (prevBtn) prevBtn.style.display = 'none';
        if (nextBtn) nextBtn.style.display = 'none';
        return;
      }
      if (prevBtn) { prevBtn.style.display = ''; prevBtn.disabled = false; }
      if (nextBtn) { nextBtn.style.display = ''; nextBtn.disabled = false; }
      if (!cfg.infinite && !fadeMode) {
        if (prevBtn) prevBtn.disabled = index <= 0;
        if (nextBtn) nextBtn.disabled = index >= realCount - perView;
      }
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      if (staticMode) { dotsWrap.style.display = 'none'; return; }
      dotsWrap.style.display = '';
      var count = (fadeMode || cfg.infinite) ? realCount : (realCount - perView + 1);
      for (var i = 0; i < count; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'lumo-dot';
          b.setAttribute('aria-label', 'Ir a la diapositiva ' + (i + 1));
          b.addEventListener('click', function () { goTo(i); resetAuto(); });
          dotsWrap.appendChild(b);
        })(i);
      }
    }

    function updateDots() {
      if (!dotsWrap) return;
      var dots = dotsWrap.children;
      var active = (!fadeMode && !cfg.infinite) ? index : currentReal();
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === active);
      }
    }

    function startAuto() {
      if (!cfg.autoplay || staticMode) return;
      stopAuto();
      autoTimer = window.setInterval(function () { move(1); }, cfg.speed);
    }
    function stopAuto() { if (autoTimer) { window.clearInterval(autoTimer); autoTimer = null; } }
    function resetAuto() { if (cfg.autoplay && !staticMode) { stopAuto(); startAuto(); } }

    if (prevBtn) prevBtn.addEventListener('click', function () { move(-1); resetAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { move(1); resetAuto(); });

    root.addEventListener('mouseenter', stopAuto);
    root.addEventListener('mouseleave', startAuto);
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stopAuto(); else startAuto();
    });

    // Swipe táctil
    var sx = 0, sy = 0, swiping = false;
    viewport.addEventListener('touchstart', function (e) {
      var t = e.touches[0]; sx = t.clientX; sy = t.clientY; swiping = true;
    }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (!swiping) return; swiping = false;
      var t = e.changedTouches[0], dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { move(dx < 0 ? 1 : -1); resetAuto(); }
    }, { passive: true });

    // Botón de play en vídeos
    root.addEventListener('click', function (e) {
      var btn = e.target.closest ? e.target.closest('.lumo-play') : null;
      if (!btn) return;
      var slide = btn.closest('.lumo-slide');
      var v = slide ? slide.querySelector('video') : null;
      if (!v) return;
      if (v.paused) { v.play(); btn.style.display = 'none'; }
      else { v.pause(); btn.style.display = ''; }
    });

    // Resize
    var rt;
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () { layout(true); startAuto(); }, 200);
    });

    layout(false);
    startAuto();
    window.addEventListener('load', function () { layout(true); startAuto(); });
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-lumo-slider]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].getAttribute('data-lumo-init')) continue;
      nodes[i].setAttribute('data-lumo-init', '1');
      initSlider(nodes[i]);
    }
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', initAll);

  // Reinicio dentro del editor de temas de Shopify
  document.addEventListener('shopify:section:load', function () {
    window.setTimeout(initAll, 50);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
